import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import Button from "../component-lib/Molecules/button/Button";
import { CUSTOM_lABEL_STYLE } from "../screens/patient-screen/visit-flow/constant";
import Heading from "../component-lib/Atoms/heading/EventEHRHeading";
import useDeviceType from "../custom-hooks/DeviceType";
import SelectDropdown from "../component-lib/Atoms/Select/Select";
import {
  TYPE_OF_TRANSFER,
  TYPE_OF_TRANSFER_DISPOSITION_DATA,
} from "./constants";
import BundleOrderModal from "../screens/patient-screen/visit-flow/dialogs/BundleOrderModal";
import {
  componentKey,
  setBundleOrderData,
} from "../screens/patient-screen/patientSlice";
import { useDispatch, useSelector } from "react-redux";
import { getFacilities } from "../screens/patient-screen/patientSaga";
import BundleOrderDisplay from "../screens/patient-screen/visit-flow/dialogs/BundelOrderDisplay";

interface EKGOrderFormProps {
  getFormData: (data: any) => void;
}

export default function TransferOffPropertiesForm({
  getFormData,
}: EKGOrderFormProps) {
  const deviceType = useDeviceType();
  const [bundleModalOpen, setBundleModalOpen] = useState(false);

  const dispatch = useDispatch();
  const { facilityData } = useSelector((state: any) => state[componentKey]);

  // The "hospital" list for offsite transfers is the departments of the
  // "Offsite Transfers" facility (configurable by admins) — mirrors JHC.
  const offsiteFacility = facilityData?.find((data: any) =>
    data?.name?.toLowerCase()?.includes("offsite")
  );
  const departmentList =
    offsiteFacility?.department?.map((data: any) => ({
      label: data?.name,
      value: data?.id,
    })) || [];

  useEffect(() => {
    try {
      dispatch(getFacilities());
    } catch (error) {
      console.log("error", error);
    }
  }, []);

  const validationSchema = Yup.object().shape({
    [TYPE_OF_TRANSFER_DISPOSITION_DATA?.PROPERTY]: Yup.string().required(
      "Property is required"
    ),
    [TYPE_OF_TRANSFER_DISPOSITION_DATA?.HOSPITAL]: Yup.string().required(
      "hospital name is required"
    ),
  });

  return (
    <>
      <Formik
        initialValues={{
          [TYPE_OF_TRANSFER_DISPOSITION_DATA?.PROPERTY]: "",
          [TYPE_OF_TRANSFER_DISPOSITION_DATA?.HOSPITAL]: "",
        }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => {
          try {
            getFormData(values);
          } catch (error) {
            console.log(error);
          } finally {
            setSubmitting(false); // Reset submitting state
          }
        }}
      >
        {({
          errors,
          values,
          touched,
          isValid,
          dirty,
          setFieldValue,
          handleBlur,
          handleSubmit,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div
                className="h-full flex flex-col justify-between gap-6"
                style={{
                  height: deviceType === "mobile" ? "40vh" : "fit-content",
                  overflow: "auto",
                }}
              >
                {/* PROPERTY DROPDOWN */}
                <div>
                  <Heading
                    title="Hospital Name"
                    customStyle={CUSTOM_lABEL_STYLE}
                  />
                  <SelectDropdown
                    label=""
                    displayEmpty={true}
                    placeholderValue={"Select Hospital Name"}
                    value={values[TYPE_OF_TRANSFER_DISPOSITION_DATA.HOSPITAL]}
                    options={departmentList}
                    onChangeCb={(e: any) =>
                      setFieldValue(
                        TYPE_OF_TRANSFER_DISPOSITION_DATA.HOSPITAL,
                        e.target.value
                      )
                    }
                    error={
                      touched[TYPE_OF_TRANSFER_DISPOSITION_DATA.HOSPITAL] &&
                      Boolean(
                        errors[TYPE_OF_TRANSFER_DISPOSITION_DATA.HOSPITAL]
                      )
                    }
                    helperText={
                      touched[TYPE_OF_TRANSFER_DISPOSITION_DATA.HOSPITAL]
                        ? errors[TYPE_OF_TRANSFER_DISPOSITION_DATA.HOSPITAL]
                        : undefined
                    }
                  />
                </div>

                {/* PROPERTY DROPDOWN */}
                <div>
                  <Heading title="Property" customStyle={CUSTOM_lABEL_STYLE} />
                  <SelectDropdown
                    label=""
                    displayEmpty={true}
                    placeholderValue={"Select Transport Level"}
                    value={values[TYPE_OF_TRANSFER_DISPOSITION_DATA.PROPERTY]}
                    options={TYPE_OF_TRANSFER}
                    onChangeCb={(e: any) =>
                      setFieldValue(
                        TYPE_OF_TRANSFER_DISPOSITION_DATA.PROPERTY,
                        e.target.value
                      )
                    }
                    error={
                      touched[TYPE_OF_TRANSFER_DISPOSITION_DATA.PROPERTY] &&
                      Boolean(
                        errors[TYPE_OF_TRANSFER_DISPOSITION_DATA.PROPERTY]
                      )
                    }
                    helperText={
                      touched[TYPE_OF_TRANSFER_DISPOSITION_DATA.PROPERTY]
                        ? errors[TYPE_OF_TRANSFER_DISPOSITION_DATA.PROPERTY]
                        : undefined
                    }
                  />
                </div>
              </div>
            <BundleOrderDisplay/>
              
              {/* ACTION BUTTONS */}
              <div className="mt-9 text-end flex gap-2 justify-end">
                {/* <Button
                  type="button"
                  label="Create Bundle Order"
                  variant="outlined"
                  onClickCb={() => {
                    setBundleModalOpen(true);
                  }}
                  style={{
                    padding: "8px 24px",
                    fontSize: "16px",
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    backgroundColor: "white",
                    marginRight: "12px",
                  }}
                /> */}
                <Button
                  // disabled={!isValid} // Button disabled if form is invalid or submitting
                  type="submit"
                  label="Submit"
                  variant="contained"
                  onClickCb={() => {}}
                  style={{
                    padding: "8px 55px",
                    fontSize: "16px",
                  }}
                ></Button>
              </div>
            </Form>
          );
        }}
      </Formik>

      <BundleOrderModal
        open={bundleModalOpen}
        handleClose={() => setBundleModalOpen(false)}
        handleSave={(data) => {
          console.log("Bundle Order Data:", data);
          dispatch(setBundleOrderData(data));
          setBundleModalOpen(false);
        }}
      />
    </>
  );
}
